var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['new-year-header', {close: _vm.isClose}]},[(!_vm.isClose)?_c('img',{staticClass:"close",attrs:{"src":require("@/assets/image/index/new-year-header-close.png")},on:{"click":function($event){$event.stopPropagation();_vm.isClose = true}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }